import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCollection = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			fillRule: "nonzero",
			children: [/* @__PURE__ */ _jsx("path", { d: "M20.12 6.71l-2.83-2.83A3 3 0 0015.17 3H8.83a3 3 0 00-2.12.88L3.88 6.71A3 3 0 003 8.83V18a3 3 0 003 3h12a3 3 0 003-3V8.83a3 3 0 00-.88-2.12zm-12-1.42A1.05 1.05 0 018.83 5h6.34c.265.004.518.107.71.29L17.59 7H6.41l1.71-1.71zM18 19H6a1 1 0 01-1-1V9h14v9a1 1 0 01-1 1z" }), /* @__PURE__ */ _jsx("path", { d: "M15 11a1 1 0 00-1 1 2 2 0 11-4 0 1 1 0 00-2 0 4 4 0 108 0 1 1 0 00-1-1z" })]
		})
	})
});
export { SvgCollection as ReactComponent };
